<div>
  <div class="cooking-header">
    <div class="title">
      <img src="assets/cookingbook/fridge-blue.svg" alt="" />

      <p>آشپزخانه</p>
    </div>
    <img src="assets/cookingbook/angle-down.svg" (click)="cancel()" alt="" />
  </div>
  <div>
    <p class="move-title">انتقال مواد انتخاب شده به آشپزخانه</p>
    <div class="button-holder">
      <div class="move-btn" (click)="move()">
        <span>{{ data.length }}</span>
        منتقل کن
      </div>
      <div class="cancel" (click)="cancel()">
        <img src="assets/cookingbook/cancel-fill.svg" alt="" />
        منصرف شدم
      </div>
    </div>
  </div>
</div>
